import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import ImageVersioningContext from 'context/ImageVersioningContext'
import Version from 'components/Version'

const AtractLoop = ({ history, logo, message }) => {
  const goToRevenuesList = () => {
    history.push('/revenueCenters')
  }

  const { version } = useContext(ImageVersioningContext)

  return (
    <section className="attract-loop" onClick={goToRevenuesList}>
      {logo && <img alt="" className="attract-loop__board-logo" src={`${logo}?${version}`} />}
      {message && <div className="attract-loop__board-message">{message}</div>}
      <Version className="attract-loop__version" />
    </section>
  )
}

AtractLoop.propTypes = {
  history: PropTypes.object,
  logo: PropTypes.string,
  message: PropTypes.string,
}

export default withRouter(AtractLoop)
